import { create } from "zustand";

// stack entry: { field, value }  — merged into WHERE filters, deeper = narrower
function syncURL(state) {
  const url = new URL(window.location.href);
  if (state.open && state.module) {
    url.searchParams.set("dm", state.module);
    url.searchParams.set("ds", state.stack.map((e) => `${e.field}:${encodeURIComponent(e.value)}`).join("|"));
    if (state.next) url.searchParams.set("dn", state.next);
    else url.searchParams.delete("dn");
  } else {
    url.searchParams.delete("dm");
    url.searchParams.delete("ds");
    url.searchParams.delete("dn");
  }
  window.history.replaceState(null, "", url.toString());
}

export const useDrill = create((set, get) => ({
  open: false,
  module: null,
  stack: [],
  next: null, // alternate-dimension override for the next groupBy level

  openAt: (module, seed = [], next = null) => {
    set({ open: true, module, stack: seed, next });
    syncURL(get());
  },
  push: (entry, next = null) => {
    set((s) => ({ stack: [...s.stack, entry], next }));
    syncURL(get());
  },
  popTo: (depth) => {
    set((s) => ({ stack: s.stack.slice(0, depth), next: null }));
    syncURL(get());
  },
  setNext: (next) => {
    set({ next });
    syncURL(get());
  },
  close: () => {
    set({ open: false, stack: [], next: null, module: null });
    syncURL(get());
  },
  restoreFromURL: () => {
    const p = new URLSearchParams(window.location.search);
    const dm = p.get("dm");
    if (!dm) return;
    const stack = (p.get("ds") || "")
      .split("|")
      .filter(Boolean)
      .map((s) => {
        const i = s.indexOf(":");
        return { field: s.slice(0, i), value: decodeURIComponent(s.slice(i + 1)) };
      });
    set({ open: true, module: dm, stack, next: p.get("dn") || null });
  },
}));

export const mergedFilters = (stack) => Object.fromEntries(stack.map((e) => [e.field, e.value]));
